var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('b',[_vm._v("["+_vm._s(_vm.history.data.title || _vm.history.data.name || _vm.history.data.nickname)+"]")]),_vm._v(_vm._s(_vm.HISTORY_TEXT[_vm.history.event])+" "),_c('span',[_vm._v(_vm._s(_vm.date))])])}
var staticRenderFns = []

export { render, staticRenderFns }